import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';

const CACHE_MAX_AGE_MILLISECONDS = 5 * 60 * 1000;
let cachedData: Promise<any> | null = null;
let cachedDataDate: Date | null = null;
function getCachedData(): Promise<any> | null {
    if (!cachedData) {
        return cachedData;
    }
    return cachedData.then((data) => {
        return JSON.parse(JSON.stringify(data));
    })
}

@Injectable()
export class SchoolService extends ServiceGlobal {
    school_id: any;
    code: string;
    name_en: string;
    name_zh: string;
    type: any;
    active: number;
    name_alpha: any = 'name_en';
    api_find_all: any = 'school_list';
    api_find_one: any = 'schools';
    loading: any = false;
    primary_key: any = 'school_id';
    api_delete: any = 'schools';
  tableName() { return 'school'; }

    async getSchoolList() {
      return await this._db.getCsv(API.GET_SCHOOL_LIST);
    }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "school_id": "School Id",
            "code": "Short Code",
            "name_en": "School Name",
            "name_zh": "Chinese Name",
            "type": "Gender",
            "active": "Active",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "school_id": {
                "type": "int",
                "auto_increment": true,
                "primary_key": true,
                "size": 11,
                'search': true,
            },
            "code": {
                "type": "string",
                "size": 255,
                "require" : {
                    "empty": true,
                }
            },
            "name_en": {
                "type": "string",
                "size": 255,
                "require": {
                    "empty": true,
                },
                'search': {
                    'op'    : 'like',
                    'value' : '{value}%',
                }
            },
            "name_zh": {
                "type": "string",
                "size": 255
            },
            "type": {
                "type": "int",
                "size": 11,
                "default": 0,
                "require": {
                  "empty": true,
                },
            },
            "active": {
                "default": 1,
                "type": "tinyint",
                "size": 1,
                'search': true,
            },
            "createddate": {
                'search': true,
            }
        });
    }

    active_inactive(ids, type) {
        var link = API.SCHOOL_ACTIVE_INACTIVE + ids.join(',');
        return this._db.put(link, {active: type});
    }

    save(update=false) {
        cachedData = null;
        cachedDataDate = null;
        var link = API.CREATE_SCHOOL;
        let attrs = this.getAttributes();

        if(update) {
            attrs = this.getAttributesUpdate();
            link += '/' + attrs['school_id'];
            delete attrs['school_id'];
            return this._db.put(link, attrs);
        }
        return this._db.post(link, attrs);
    }

    findAll(condition: any = {}, limit: number = 0, offset: number = 0) {
        let result: Promise<any>;
        if (arguments.length === 0 ||
            (
                (!condition || JSON.stringify(condition) === '{}') &&
                !limit &&
                !offset
            )
        ) {
            const now = new Date();
            if (cachedDataDate == null ||
                    (+now - +cachedDataDate) > CACHE_MAX_AGE_MILLISECONDS
            ) {
                cachedDataDate = now;
                cachedData = super.findAll.apply(this, arguments);
                result = getCachedData();
            } else {
                result = cachedData;
            }
        } else {
            result = super.findAll.apply(this, arguments);
        }
        return result;
    }

    delete(id = false): Promise<any> {
        cachedData = null;
        cachedDataDate = null;
        return super.delete.apply(this, arguments);
    }
    deleteAll(condition: any, params: any = false): Promise<any> {
        cachedData = null;
        cachedDataDate = null;
        return super.deleteAll.apply(this, arguments);
    }
    insert(): Promise<any> {
        cachedData = null;
        cachedDataDate = null;
        return super.insert.apply(this, arguments);
    }
    update(): Promise<any> {
        cachedData = null;
        cachedDataDate = null;
        return super.update.apply(this, arguments);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/school.service.ts